import { render } from "./HeroCard.vue?vue&type=template&id=de97f10c"
import script from "./HeroCard.vue?vue&type=script&lang=js"
export * from "./HeroCard.vue?vue&type=script&lang=js"

import "./HeroCard.vue?vue&type=style&index=0&id=de97f10c&lang=css"
script.render = render

export default script